import { APIRequest } from '../../helpers/index.helper';
import { OUTSTANDING_PAYMENTS_ENDPOINT } from '../../apiEndpoints/OutstandingPayments/index.endpoint';

export const getOutstandingPaymentsListService = async ({ queryParams } = {}) => {
  return await APIRequest({
    ...OUTSTANDING_PAYMENTS_ENDPOINT.getList,
    queryParams,
  });
};

export const getCustomerOutstandingDetailService = async (customerId, queryParams = {}) => {
  return await APIRequest({
    ...OUTSTANDING_PAYMENTS_ENDPOINT.getDetail(customerId),
    queryParams,
  });
};

export const sendOutstandingPaymentLinkService = async (data) => {
  return await APIRequest({
    ...OUTSTANDING_PAYMENTS_ENDPOINT.sendPaymentLink,
    bodyData: data,
  });
};

export const markInvoicePaidService = async (data) => {
  return await APIRequest({
    ...OUTSTANDING_PAYMENTS_ENDPOINT.markPaid,
    bodyData: data,
  });
};
